module.exports = __webpack_public_path__ + "static/img/water-drop-not.a0cc6cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/water-drop-not.png
// module id = DR5s
// module chunks = 1